class BytesFormat {

    constructor() {

        return (size) => {
            if(typeof size != 'undefined'){
                let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (size === 0) {
                    return 'N/A';
                }
                let i = parseInt(Math.floor(Math.log(size) / Math.log(1024)));
                return (size / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
            }
        };
    }

}

angular.module('cpm')
.filter('bytesFormat', [ () => {
    'use strict';
    return new BytesFormat();
}]);

